/**
 * 判断值是否为数字
 * @return 是否为数字
 */
export default function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=is-number.js.map